import { render, staticRenderFns } from "./lotto-game-select.vue?vue&type=template&id=55f02292&"
import script from "./lotto-game-select.vue?vue&type=script&lang=js&"
export * from "./lotto-game-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports